export default {
  name: "PremiacaoPanel",
  props: {
    medalha: String,
    premiados: Array,
    ouroEspecial: {
      type: Boolean,
      default: false
    },
    ouro: {
      type: Boolean,
      default: false
    },
    prata: {
      type: Boolean,
      default: false
    },
    bronze: {
      type: Boolean,
      default: false
    }
  }
};